"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deleteDirectVehicleIncome_1 = __importDefault(require("./deleteDirectVehicleIncome"));
const deleteMonthlyVehicleExpenses_1 = __importDefault(require("./deleteMonthlyVehicleExpenses"));
const deleteVehicle_1 = __importDefault(require("./deleteVehicle"));
const deleteVehicleCommentary_1 = __importDefault(require("./deleteVehicleCommentary"));
const deleteVehicleExpiration_1 = __importDefault(require("./deleteVehicleExpiration"));
const getLatestVehicleExpirations_1 = __importDefault(require("./getLatestVehicleExpirations"));
const getPreviousMonthlyVehicleExpenses_1 = __importDefault(require("./getPreviousMonthlyVehicleExpenses"));
const getVehicleDuplcate_1 = __importDefault(require("./getVehicleDuplcate"));
const getVehicle_1 = __importDefault(require("./getVehicle"));
const getVehicleActivity_1 = __importDefault(require("./getVehicleActivity"));
const getVehicleProfitHighlights_1 = __importDefault(require("./getVehicleProfitHighlights"));
const getVehicleMileageHighlights_1 = __importDefault(require("./getVehicleMileageHighlights"));
const getVehicleExpensesHighlights_1 = __importDefault(require("./getVehicleExpensesHighlights"));
const getVehicleTravelsHighlights_1 = __importDefault(require("./getVehicleTravelsHighlights"));
const getVehicleRevenueHighlights_1 = __importDefault(require("./getVehicleRevenueHighlights"));
const getYearlyVehicleExpenses_1 = __importDefault(require("./getYearlyVehicleExpenses"));
const postDirectVehicleIncome_1 = __importDefault(require("./postDirectVehicleIncome"));
const postMonthlyVehicleExpenses_1 = __importDefault(require("./postMonthlyVehicleExpenses"));
const postVehicle_1 = __importDefault(require("./postVehicle"));
const postVehicleAvatar_1 = __importDefault(require("./postVehicleAvatar"));
const postVehicleCommentary_1 = __importDefault(require("./postVehicleCommentary"));
const postVehicleExpiration_1 = __importDefault(require("./postVehicleExpiration"));
const postVehicleExpirationImage_1 = __importDefault(require("./postVehicleExpirationImage"));
const postVehicleExpirationMatchQuery_1 = __importDefault(require("./postVehicleExpirationMatchQuery"));
const postVehicleIncomeMatchQuery_1 = __importDefault(require("./postVehicleIncomeMatchQuery"));
const postVehicleMatchQuery_1 = __importDefault(require("./postVehicleMatchQuery"));
const postVehicleSuggestQuery_1 = __importDefault(require("./postVehicleSuggestQuery"));
const putDirectVehicleIncome_1 = __importDefault(require("./putDirectVehicleIncome"));
const putMonthlyVehicleExpenses_1 = __importDefault(require("./putMonthlyVehicleExpenses"));
const putVehicle_1 = __importDefault(require("./putVehicle"));
const putVehicleCommentary_1 = __importDefault(require("./putVehicleCommentary"));
const putVehicleExpiration_1 = __importDefault(require("./putVehicleExpiration"));
const createVehicleClient = (axios) => ({
    deleteDirectVehicleIncome: ({ vehicleId, incomeId }) => deleteDirectVehicleIncome_1.default({
        axios,
        vehicleId,
        incomeId
    }),
    deleteMonthlyVehicleExpenses: ({ vehicleId, year, month }) => deleteMonthlyVehicleExpenses_1.default({
        axios,
        vehicleId,
        year,
        month
    }),
    deleteVehicle: ({ vehicleId }) => deleteVehicle_1.default({ axios, vehicleId }),
    deleteVehicleCommentary: ({ vehicleId, commentaryId }) => deleteVehicleCommentary_1.default({
        axios,
        vehicleId,
        commentaryId
    }),
    deleteVehicleExpiration: ({ vehicleId, expirationId }) => deleteVehicleExpiration_1.default({ axios, vehicleId, expirationId }),
    getLatestVehicleExpirations: ({ vehicleId }) => getLatestVehicleExpirations_1.default({ axios, vehicleId }),
    getPreviousMonthlyVehicleExpenses: ({ vehicleId, year }) => getPreviousMonthlyVehicleExpenses_1.default({ axios, vehicleId, year }),
    getVehicle: ({ vehicleId }) => (getVehicle_1.default({ axios, vehicleId })),
    getVehicleActivity: ({ vehicleId }) => (getVehicleActivity_1.default({ axios, vehicleId })),
    getVehicleExpensesHighlights: ({ vehicleId, currency, period, timezone }) => getVehicleExpensesHighlights_1.default({
        axios,
        vehicleId,
        currency,
        period,
        timezone
    }),
    getVehicleTravelsHighlights: ({ vehicleId, period, timezone }) => getVehicleTravelsHighlights_1.default({
        axios,
        vehicleId,
        period,
        timezone
    }),
    getVehicleProfitHighlights: ({ vehicleId, currency, period, timezone }) => getVehicleProfitHighlights_1.default({
        axios,
        vehicleId,
        currency,
        period,
        timezone
    }),
    getVehicleMileageHighlights: ({ vehicleId, period, timezone }) => getVehicleMileageHighlights_1.default({
        axios,
        vehicleId,
        period,
        timezone
    }),
    getVehicleRevenueHighlights: ({ vehicleId, currency, period, timezone }) => getVehicleRevenueHighlights_1.default({
        axios,
        vehicleId,
        currency,
        period,
        timezone
    }),
    getYearlyVehicleExpenses: ({ vehicleId, year }) => getYearlyVehicleExpenses_1.default({ axios, vehicleId, year }),
    getVehicleDuplicate: ({ vin }) => getVehicleDuplcate_1.default({ axios, vin }),
    postDirectVehicleIncome: ({ vehicleId, income }) => postDirectVehicleIncome_1.default({
        axios,
        vehicleId,
        income
    }),
    postMonthlyVehicleExpenses: ({ vehicleId, year, month, expenses }) => postMonthlyVehicleExpenses_1.default({
        axios,
        vehicleId,
        year,
        month,
        expenses
    }),
    postVehicle: ({ vehicle }) => postVehicle_1.default({ axios, vehicle }),
    postVehicleAvatar: ({ vehicleId, avatarFile }) => postVehicleAvatar_1.default({
        axios,
        vehicleId,
        avatarFile
    }),
    postVehicleCommentary: ({ vehicleId, commentary }) => postVehicleCommentary_1.default({ axios, vehicleId, commentary }),
    postVehicleExpiration: ({ vehicleId, expiration }) => postVehicleExpiration_1.default({ axios, vehicleId, expiration }),
    postVehicleExpirationImage: ({ imageFile }) => postVehicleExpirationImage_1.default({ axios, imageFile }),
    postVehicleExpirationMatchQuery: ({ vehicleId, query }) => postVehicleExpirationMatchQuery_1.default({
        axios,
        vehicleId,
        query
    }),
    postVehicleIncomeMatchQuery: ({ vehicleId, query }) => postVehicleIncomeMatchQuery_1.default({
        axios,
        vehicleId,
        query
    }),
    postVehicleMatchQuery: ({ query }) => postVehicleMatchQuery_1.default({
        axios,
        query
    }),
    postVehicleSuggestQuery: ({ query }) => postVehicleSuggestQuery_1.default({ axios, query }),
    putDirectVehicleIncome: ({ vehicleId, incomeId, income }) => putDirectVehicleIncome_1.default({
        axios,
        vehicleId,
        incomeId,
        income
    }),
    putMonthlyVehicleExpenses: ({ vehicleId, year, month, expenses }) => putMonthlyVehicleExpenses_1.default({
        axios,
        vehicleId,
        year,
        month,
        expenses
    }),
    putVehicle: ({ vehicleId, vehicle }) => putVehicle_1.default({ axios, vehicleId, vehicle }),
    putVehicleCommentary: ({ vehicleId, commentaryId, commentary }) => putVehicleCommentary_1.default({
        axios,
        vehicleId,
        commentaryId,
        commentary
    }),
    putVehicleExpiration: ({ vehicleId, expirationId, expiration }) => putVehicleExpiration_1.default({
        axios,
        vehicleId,
        expirationId,
        expiration
    })
});
exports.default = createVehicleClient;
